import { CombinedTableRowProps } from '../../../types/molecules/tableRow.types'
import { ForwardRefExoticComponent, forwardRef } from 'react'
import { TableRowBase } from './styles'

const TableRow: ForwardRefExoticComponent<CombinedTableRowProps> = forwardRef<
  HTMLTableRowElement,
  CombinedTableRowProps
>((props: CombinedTableRowProps, ref) => {
  const { children, ...rest } = props
  return (
    <TableRowBase ref={ref} aria-label="table-row" {...rest}>
      {children}
    </TableRowBase>
  )
})

TableRow.displayName = 'TableRow'

export { TableRow }
